export const STATIC_URL = 'https://static.kimcaddie.com';
export const S3_BASE_URL = `${STATIC_URL}/kaddie`;
